import React, { useCallback, useEffect, useState } from 'react'
import { BsFillStarFill } from 'react-icons/bs';
import useApi from '../../hooks/useApi';
import { Osc } from '../../types/Osc'
import { SpinnerLoad } from '../Loading/SpinnerLoad';
import { OscInfo } from './OscInfo'

export const ApproveOsc = ({ currentOsc , oscArea}: Props) => {

    const [load, setLoad] = useState<boolean>(false);
    const [osc, setOsc] = useState<Osc>()

    const api = useApi()

    const loadOsc = useCallback(async () => {
        setLoad(true);
        let link = oscArea ? "client/me/all" :  `admin/osc/${currentOsc.id}`
        api.get(link).then(res => {
            setOsc(res.data)
        }).catch(console.log)
        setLoad(false)
    }, [api, setOsc , oscArea,currentOsc])
    

    useEffect(() => {
        loadOsc()
    }, [loadOsc])

    return (
        <div className='flex flex-col itens-center p-3 gap-y-5'>
            {!load && osc && <>
                <div className='font-bold'>Dados Gerais</div>
                <div className='grid grid-cols-2 gap-y-2 p-3 border-l-4 border-green-500 rounded-md'>
                    <OscInfo title='CNPJ:' text={osc.document} />
                    <OscInfo title="Razão social:" text={osc.corporate_name} />
                    <OscInfo title="Nome fantasia:" text={osc.fantasy_name} />
                    <OscInfo title="Data de fundação:" text={osc.fundation_date} />
                    <OscInfo title="Descrição:" text={osc.description} />
                </div>
                <div className='font-bold'>Localização</div>
                <div className='grid grid-cols-2 gap-y-2 p-3 border-l-4 border-green-500 rounded-md'>
                    <OscInfo title="Cep:" text={osc.location?.code} />
                    <OscInfo title="Rua:" text={osc.location?.address} />
                    <OscInfo title="Bairro:" text={osc.location?.district} />
                    <OscInfo title="Estado:" text={osc.location?.state} />
                    <OscInfo title="Cidade:" text={osc.location?.city} />
                    <OscInfo title="Número:" text={osc.location?.number} />
                    <OscInfo title="Complemento:" text={osc.location?.complement} />
                </div>
                <div className='font-bold'>Responsavel</div>
                <div className='grid grid-cols-2 gap-y-2 p-3 border-l-4 border-green-500 rounded-md'>
                    <OscInfo title="Nome:" text={osc.responsible?.name} />
                    <OscInfo title="Contato:" text={osc.responsible?.phone} />
                    <OscInfo title="E-mail:" text={osc.responsible?.email} />
                </div>
                {osc.contact && <>
                <div className='font-bold'>Contato</div>
                <div className='grid grid-cols-2 gap-y-2 p-3 border-l-4 border-green-500 rounded-md'>
                    <OscInfo title="Telefone:" text={osc.contact.osc_phone} />
                    <OscInfo title="Celular/whatsapp:" text={osc.contact.whatsapp} />
                    <OscInfo title="Email da organização:" text={osc.contact.osc_email} />
                    <OscInfo title="Site da Organização:" text={osc.contact.site} />
                    <OscInfo title="Facebook da organização:" text={osc.contact.facebook} />
                    <OscInfo title="instagram da organização :" text={osc.contact.instagram} />
                    <OscInfo title="Outro:" text={osc.contact.other} />
                </div>
                </>
                }

                <div className='font-bold'>Respondente</div>
                <div className='grid grid-cols-2 gap-y-2 p-3 border-l-4 border-green-500 rounded-md'>
                    <OscInfo title="Nome:" text={osc.respondent?.name} />
                    <OscInfo title="Contato:" text={osc.respondent?.phone} />
                    <OscInfo title="E-mail:" text={osc.respondent?.email} />
                    <OscInfo title="Formação:" text={osc.respondent?.formation} />
                    <OscInfo title="Cargo:" text={osc.respondent?.position} />
                    <OscInfo title="Tempo na organização:" text={osc.respondent?.time_at_osc} />
                </div>
                <div className='font-bold'>Atuação e Público</div>
                <div className='grid grid-cols-2 gap-y-2 p-3 border-l-4 border-green-500 rounded-md'>
                    <OscInfo title="Instituição de acolhimento:" text={osc.performace?.shelter ? "Sim" : "Não"} />
                    <OscInfo title="Inscrição em conselhos de direitos:" text={osc.performace?.rights_councils ? osc.performace.rights_councils : "Não tem"} />
                    <div className=''>
                        <div className='font-semibold mb-1'>Causas</div>
                        <div className='grid grid-cols-1 gap-y-2'>
                            <div className='p-2 border-l-4  border-primary flex rounded-lg'>{osc.primary_cause?.name} <BsFillStarFill className='text-primary ml-4' /> </div>
                            {osc.causes?.map(item => (
                                <div key={item.id} className='p-2 border-l-4  border-green-200 flex rounded-lg'>
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className=''>
                        <div className='font-semibold mb-1'>Público Alvo</div>
                        <div className='grid grid-cols-1 gap-y-2'>
                            {osc.targets?.map(item => (
                                <div key={item.id} className='p-2 border-l-4  border-green-200 flex rounded-lg'>
                                    {item.name}
                                </div>
                            ))}
                        </div>
                    </div>

                    <OscInfo title="Beneficiários de 0 a 5:" text={osc.performace?.public_from_0_at_5} />
                    <OscInfo title="Beneficiários de 6 a 11:" text={osc.performace?.public_from_6_at_11} />
                    <OscInfo title="Beneficiários de 12 a 18:" text={osc.performace?.public_from_12_at_18} />
                    <OscInfo title="Beneficiários de 19 a 29:" text={osc.performace?.public_from_19_at_29} />
                    <OscInfo title="Beneficiários de 30 a 59:" text={osc.performace?.public_from_30_at_59} />
                    <OscInfo title="Maior de 60:" text={osc.performace?.public_over_60} />
                    <OscInfo title="Público indireto:" text={osc.performace?.public_indirect} />
                </div>
                {osc.structure &&
                <>
                <div className=''>Estrutura</div>
                <div className='grid grid-cols-2 gap-y-2 p-3 border-l-4 border-green-500 rounded-md'>
                    <OscInfo title="N° de funcionários" text={osc.structure.employees} />
                    <OscInfo title="N° de voluntarios" text={osc.structure.voluntaries} />
                    <OscInfo title="Orçamento anual" text={osc.structure.annual_budget} />
                    <OscInfo title="Sede própria" text={osc.structure.headquarters ? "Sim" : "Não"} />
                    <OscInfo title="Convênios de poder público:" text={osc.structure.public_powers? osc.structure.public_powers : "Não possui"} />
                    <OscInfo title="Possui projetos aprovados em lei de incentivo" text={osc.structure.approved_projects? osc.structure.approved_projects : "Não possui"} />
                </div>
                </>
                }
            </>
            }
            {load && <SpinnerLoad />}
        </div>
    )
}

interface Props {
    currentOsc: Osc,
    oscArea?:boolean
}